export const onDialogClose = dialogType => ({
  widget: 'projects',
  type: 'onDialogClose',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/projects/actions/onDialogClose.js